"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const deserializeNews = ({ createdAt, ...rest }) => ({
    ...rest,
    createdAt: new Date(createdAt)
});
exports.default = deserializeNews;
